
import React, { useState } from 'react';
import { usePortfolioStore } from './stores/portfolioStore';
import InsightCardDetailPanel from './InsightCardDetailPanel';
import { Box, Typography, Stack, Button } from '@mui/material';


const iconForType = (type) => {
  if (type === 'RISK') return '⚠️';
  if (type === 'OPPORTUNITY') return '💡';
  if (type === 'INFO') return 'ℹ️';
  return 'ℹ️';
};

const colorForType = (type) => {
  if (type === 'RISK') return 'error.main';
  if (type === 'OPPORTUNITY') return 'success.main';
  if (type === 'INFO') return 'text.secondary';
  return 'text.secondary';
};

const InsightCardsSection = () => {
  const insights = usePortfolioStore((s) => s.insights);
  const [selected, setSelected] = useState(null);

  if (!insights || insights.length === 0) return null;

  // Mutualisation des actions (pas de doublons)
  const allActions = Array.from(new Set(insights.flatMap(i => i.actions || [])));

  return (
    <Box sx={{ p: 3, borderRadius: 4, bgcolor: 'background.paper', mb: 3 }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
        Analyse du portefeuille
      </Typography>

      <Stack spacing={2} sx={{ mb: 3 }}>
        {insights.map((insight, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 1 }}>
            <Typography fontSize={28} sx={{ color: colorForType(insight.type), minWidth: 40 }}>
              {iconForType(insight.type)}
            </Typography>
            <Box>
              <Typography fontWeight={600}>{insight.title}</Typography>
              <Typography variant="body2" color="text.secondary">{insight.implication}</Typography>
            </Box>
          </Box>
        ))}
      </Stack>

      {allActions.length > 0 && (
        <Stack spacing={1} sx={{ mt: 3 }}>
          <Typography variant="subtitle2">Actions recommandées</Typography>
          {allActions.map((action, idx) => (
            <Button key={idx} variant="outlined" sx={{ textAlign: 'left', justifyContent: 'flex-start', width: 'fit-content' }}>
              {action}
            </Button>
          ))}
        </Stack>
      )}

      {/* Optionnel : panneau de détail si besoin */}
      {selected && (
        <InsightCardDetailPanel insight={selected} onClose={() => setSelected(null)} />
      )}
    </Box>
  );
};

export default InsightCardsSection;
